import Images from "../utils/Images";

export const rootOptions = [
  {
    key: "insurance",
    title: "Insurance",
    subtitle: "Your trusted protection partner",
    image: Images.insurance_card
  },
  {
    key: "travel",
    title: "Travel, Tour & Logistics",
    subtitle: "Seamless journeys, stress free logistics",
    image: Images.travel_card,
    comingSoon: true,
  },
  {
    key: "tourism",
    title: "Media and Event ",
    subtitle: "Where creativity meet unforgettable experiences",
    image: Images.tourism_card,
    link: "/media-events",
  },
  {
    key: "safety",
    title: "Safety Services",
    subtitle: "Your partner in protection and safety",
    image: Images.safety_card,
    comingSoon: true,
  },
];

export const insuranceOptions = [
  {
    key: "road-trip",
    title: "Tripsecure Insurance",
    link: "/insurance/road-trip",
    subtitle: "Reliable coverage for every journey on the road.",
    image: Images.ts_shield,
  },
  {
    key: "travel",
    title: "Travel Insurance",
    link: "/insurance/travel",
    subtitle: "Reliable protection for your air travels.",
    image: Images.travel_insurance,
  },
  {
    key: "life",
    title: "Life Insurance",
    link: "/insurance/life",
    subtitle: "Secure your loved ones, secure your future",
    image: Images.life_insurance,
  },
  {
    key: "general",
    title: "General Insurance",
    link: "/insurance/general",
    subtitle: "Protection for every part of your life",
    image: Images.general_insurance,
  },
];

export const mediaOptions = [
  {
    key: "conference-trade-mission",
    title: "Conf. & Trade Mission",
    subtitle: "Conf. & Trade Mission Coverage",
    image: Images.conference_illustrator,
    link: "/conference-trade-mission",
  },
  {
    key: "event",
    title: "Events",
    subtitle: "Events Coverage and Seminars",
    image: Images.events_illustrator,
    link: "/events",
  },
  {
    key: "tour",
    title: "Tour Packages",
    subtitle: "Affordable Holiday Tour Packages",
    image: Images.tour_packages_illustrator,
  }
  
];

export const travelOptions = [
  {
    key: "flights",
    title: "Flight Protection",
    subtitle: "Delay and cancellation cover",
    image:
      "https://images.unsplash.com/photo-1474302770737-173ee21bab63?auto=format&fit=crop&w=700&q=60",
  },
  {
    key: "baggage",
    title: "Baggage Cover",
    subtitle: "Lost or delayed baggage",
    image:
      "https://images.unsplash.com/photo-1518546305927-5a555bb7020d?auto=format&fit=crop&w=700&q=60",
    comingSoon: true,
  },
  {
    key: "accommodation",
    title: "Accommodation Cover",
    subtitle: "Unexpected changes",
    image:
      "https://images.unsplash.com/photo-1528909514045-2fa4ac7a08ba?auto=format&fit=crop&w=700&q=60",
    comingSoon: true,
  },
  {
    key: "rental",
    title: "Car Rental Cover",
    subtitle: "Drive with confidence",
    image:
      "https://images.unsplash.com/photo-1493238792000-8113da705763?auto=format&fit=crop&w=700&q=60",
    comingSoon: true,
  },
];